<div class="hc-segmented" role="radiogroup">
  <ng-content></ng-content>
</div>
